<template>
    <!-- <div class="sidebar-header"></div> -->
</template>

<script>
export default {
    name: 'sidebar-header',
};
</script>



// WEBPACK FOOTER //
// src/nav_components/SidebarHeader.vue